var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"chart-header"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.subtitle))])]),(_vm.datacollection !== null)?_c('doughnut-chart',{attrs:{"chart-data":_vm.datacollection}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }